interface BodyProps {
  children: React.ReactNode;
  styles?: React.CSSProperties;
}

const Body = (props: BodyProps) => {
  return (
    <div style={{ ...styles.container, ...props.styles }}>{props.children}</div>
  );
};

const styles = {
  container: {
    justifyContent: "center",
    paddingLeft: "100px",
    paddingRight: "100px",
    paddingBottom: "121px",
    height: "calc(100% - 256px)",
  },
};

export default Body;
